import React from 'react';
import '../App.css';
import Headerappprivateadmin from './/headerappprivateadmin'
import { Bodyapphomebodyadminusers} from './/bodyapphomebodyadminusers'
import { Footerappprivateadmin } from './/footerappprivateadmin'
import withRouter from './/withRouter'
class Bodyappadminusers extends React.Component {
    constructor(props){
        super(props);
    }
  
  componentDidMount(){
    if(window.localStorage.getItem('MY_APP_STATE_AUTHCODE') == ''){
       window.location = ('/')
    }
  }

  render(){  
    return (  
      <div className="App">        
        <Headerappprivateadmin/>
        <Bodyapphomebodyadminusers/>
        <Footerappprivateadmin/>
      </div>
    );
  }
}
export default withRouter(Bodyappadminusers);